import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { getServiceRequestDataById, sendPropsedDateAPI, allocateItems, sendMailForCustomer } from '../../Api/serviceApiMaster';
import Sample14 from "../../Components/Logo";
import { Table } from "react-bootstrap";
import moment from "moment";
import { useAuth } from '../../Context/AuthContext';
import { Link } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { MdEmail } from "react-icons/md";


const RequestData = () => {
    const { user } = useAuth();
    const location = useLocation();
    const requestId = location.pathname.split("/")[3];
    console.log("Request Id:", requestId)
    const [loading, setLoading] = useState(false);

    const [showAddModal, setShowAddModal] = useState(false);

    const initialValues = {
        allocatedQuantity: "",
        proposedDate: ""
    };
    const [selectedServiceData, setSelectedServiceData] = useState(initialValues);

    const [serviceData, setServiceData] = useState({});

    const handleEdit = (item) => {
        console.log("edit cat", item);
        setShowAddModal(true);
        setSelectedServiceData(item)
    };

    console.log(user, 'user')

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectedServiceData({ ...selectedServiceData, [name]: value });
        console.log("form vla", selectedServiceData);
    };

    const fetchRequestById = async () => {
        setLoading(true);
        try {
            const response = await getServiceRequestDataById(requestId);
            setServiceData(response);
        } catch (error) {
            toast.error(`Error loading service data: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRequestById();
    }, [requestId]);

    const sendMailforRequest = async () => {
        const res = await sendMailForCustomer(requestId, user?.customerId);
        console.log(res, 'res from email')
        if (res.status === 200) {
            toast.success("Email send to Customer");
        }
    }

    // console.log(serviceData, 'serviceData')

    const editSubmitHandler = async () => {
        // console.log(selectedServiceData, 'selectedServiceData')

        // return
        let data = {
            requestItemId: selectedServiceData?.requestItemId,
            allocatedQuantity: selectedServiceData?.allocatedQuantity ? selectedServiceData?.allocatedQuantity.toString() : "0",
            proposedDate: selectedServiceData?.proposedDate
        }

        const res = await allocateItems(data, user?.userId);
        // return
        if (res.status === 200) {
            toast.success("Allocated Successfully");

            setShowAddModal(false);
            setSelectedServiceData({})
            fetchRequestById();

        }
        // console.log(res, 'res')
    }

    console.log(selectedServiceData, 'selectedServiceData')

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="fields-container">
                    <h2 className="fields-title">Request Service</h2>
                    {loading && (
                        <div className="loading-overlay">
                            <Sample14 />
                        </div>
                    )}

                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Customer Request List</h2>
                        </div>
                        <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={sendMailforRequest}
                            >
                                <MdEmail className='file-icon' />
                            </button>
                        </div>

                    </div>

                    {serviceData?.requestItems?.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    {/* <th>Ser.</th> */}
                                    <th>Request Item Id</th>
                                    <th>Request Id</th>
                                    <th>Service Data</th>
                                    <th>Type</th>
                                    <th>quantity</th>
                                    <th>serviceHours</th>
                                    <th>Preferred Date</th>
                                    <th>Proposed Date</th>
                                    <th>Allocated Qty</th>
                                    <th> price</th>
                                    <th>amount</th>
                                    <th>cgst</th>
                                    <th>sgst</th>
                                    <th>igst</th>
                                    <th> grandTotal</th>
                                    <th>Status</th>
                                    {/* <th>Proposed Date and Time</th> */}


                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceData?.requestItems?.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{budget.requestItemId}</td>
                                        <td>{budget.requestId}</td>
                                        <td>{budget.serviceData}</td>
                                        <td>{budget.serviceType}</td>
                                        <td>{budget.quantity
                                        }</td>
                                        <td>{budget.serviceHours}</td>
                                        <td>{budget.preferredDate} at {budget?.preferredTime}</td>
                                        <td>{budget?.proposedDate ? `${budget?.proposedDate} at ${budget?.proposedTime}` : ''}</td>

                                        <td>{budget.allocatedQuantity}</td>
                                        <td>{budget.price}</td>
                                        <td>{budget.amount}</td>
                                        <td>{budget.cgst}</td>
                                        <td>{budget.sgst
                                        }</td>
                                        <td>{budget.igst}</td>
                                        <td>{budget.grandTotal
                                        }</td>
                                        <td>{budget.serviceStatusName}</td>
                                        <td>

                                            <Button className="edit-link" onClick={() => {
                                                handleEdit(budget);
                                            }}>
                                                <FaPencilAlt className="edit-icon" />
                                            </Button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Data found.</p>
                    )}
                </Container>
            </div>


            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <div className="modelMain  modal-dialog-centered ">
                    <Modal.Body className="modelBody ">
                        <div className="m-2">
                            <h6>Request Item Id: {selectedServiceData?.requestItemId}</h6>
                            <p style={{marginBottom: 0}}>Parent Id : {selectedServiceData?.requestId}</p>
                            <p>Preffered Date : {selectedServiceData?.preferredDate} at {selectedServiceData?.preferredTime}</p>

                            <Container>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Proposed Date</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                placeholder="Proposed Date"
                                                name="proposedDate"
                                                value={selectedServiceData.proposedDate}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {selectedServiceData?.serviceType === 'service' ? (
                                        <></>
                                    ) : (
                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Allocate Item</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Item Allocation"
                                                    name="allocatedQuantity"
                                                    value={selectedServiceData.allocatedQuantity}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}

                                </Row>
                                <Row>
                                    <div className="modelFooter justify-content-center">
                                        <button
                                            className="mainButton modelBtn bg-warning"
                                            variant="secondary"
                                            onClick={() => {
                                                setShowAddModal(false);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="mainButton modelBtn bg-success"
                                            variant="primary"
                                            onClick={editSubmitHandler}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Row>
                            </Container>
                        </div>

                    </Modal.Body>
                </div >
            </Modal >

        </>
    )
}

export default RequestData